import { unByKey } from 'ol/Observable.js';
import Overlay from 'ol/Overlay.js';
import { getArea, getLength } from 'ol/sphere.js';
import { LineString, Polygon } from 'ol/geom.js';
import Draw from 'ol/interaction/Draw.js';
import { transform } from 'ol/proj';
import { Vector as VectorLayer } from 'ol/layer.js';
import { Vector as VectorSource } from 'ol/source.js';
import { Circle as CircleStyle, Fill, Stroke, Style } from 'ol/style.js';

var tooltipOverlaysArea = [];
var vertexCoordinateOverlays = [];

var sourceArea = new VectorSource();

var vectorArea = new VectorLayer({
  source: sourceArea,
  style: new Style({
    fill: new Fill({
      color: 'rgba(255, 255, 255, 0.2)'
    }),
    stroke: new Stroke({
      color: '#ffcc33',
      width: 2
    }),
    image: new CircleStyle({
      radius: 7,
      fill: new Fill({
        color: '#ffcc33'
      })
    })
  })
});

var isVectorArea = false;
var sketch;
var helpTooltipElement;
var helpTooltipArea;
var measureTooltipElement;
var measureTooltip;
var continuePolygonMsg = 'Haga click para continuar dibujando el polígono';
var continueLineMsg = 'Haga click para continuar dibujando la línea';
var drawArea;

var formatLength = function (line) {
  var length = getLength(line);
  var output = (Math.round(length * 100) / 100) + ' ' + 'm';
  return output;
};

var formatArea = function (polygon) {
  var area = getArea(polygon);
  var output = (Math.round(area * 100) / 100) + ' ' + 'm<sup>2</sup>';
  return output;
};

function pointerMoveArea(evt) {
  if (evt.dragging) {
    return;
  }

  var helpMsg = 'Haga click para comenzar a dibujar';
  if (sketch) {
    var geom = (sketch.getGeometry());
    if (geom instanceof Polygon) {
      helpMsg = continuePolygonMsg;
    } else if (geom instanceof LineString) {
      helpMsg = continueLineMsg;
    }
  }

  helpTooltipElement.innerHTML = helpMsg;
  helpTooltipArea.setPosition(evt.coordinate);
  helpTooltipElement.classList.remove('hidden');
  helpTooltipElement.style.display = 'inherit';
}

function mouseOutArea() {
  helpTooltipElement.classList.add('hidden');
  helpTooltipElement.style.display = 'none';
}

export const measureArea = {
  methods: {
    checkDuplicateCoordinate: function (coordinate) {
      if (!coordinate || !Array.isArray(coordinate) || coordinate.length < 2) {
        return false;
      }

      const tolerance = 0.000001;

      return vertexCoordinateOverlays.some(overlay => {
        const pos = overlay.getPosition();
        return pos &&
          Math.abs(pos[0] - coordinate[0]) < tolerance &&
          Math.abs(pos[1] - coordinate[1]) < tolerance;
      });
    },

    addAreaInteraction: function () {
      console.log('add interaction 2');
      var that = this;
      var type = 'Polygon';
      drawArea = new Draw({
        source: sourceArea,
        type: type,
        style: new Style({
          fill: new Fill({
            color: 'rgba(255, 255, 255, 0.2)'
          }),
          stroke: new Stroke({
            color: 'rgba(0, 0, 0, 0.5)',
            lineDash: [10, 10],
            width: 2
          }),
          image: new CircleStyle({
            radius: 5,
            stroke: new Stroke({
              color: 'rgba(0, 0, 0, 0.7)'
            }),
            fill: new Fill({
              color: 'rgba(255, 255, 255, 0.2)'
            })
          })
        })
      });
      this.map.addInteraction(drawArea);

      this.createMeasureTooltip();
      this.createHelpTooltip();

      var listener;
      drawArea.on('drawstart', function (evt) {
        // Limpiar dibujo y tooltips anteriores antes de empezar el nuevo
        sourceArea.clear();
        that.map.getOverlays().getArray().slice().forEach(overlay => {
          const type = overlay.get('type');
          if (type === 'area' || type === 'area-coordinate') {
            that.map.removeOverlay(overlay);
          }
        });
        tooltipOverlaysArea = [];
        vertexCoordinateOverlays = [];

        sketch = evt.feature;
        var tooltipCoord = evt.coordinate;

        listener = sketch.getGeometry().on('change', function (evt) {
          var geom = evt.target;
          var output;
          if (geom instanceof Polygon) {
            output = formatArea(geom);
            tooltipCoord = geom.getInteriorPoint().getCoordinates();
            // Reportar valor bruto al componente
            if (typeof that.updateRawValue === 'function') {
              that.updateRawValue(getArea(geom));
            }
          } else if (geom instanceof LineString) {
            output = formatLength(geom);
            tooltipCoord = geom.getLastCoordinate();
          }
          measureTooltipElement.innerHTML = output;
          measureTooltip.setPosition(tooltipCoord);
        });
      });

      drawArea.on('drawend', function () {
        // Primero, limpiar cualquier overlay previo de vértices
        for (let i = 0; i < vertexCoordinateOverlays.length; i++) {
          that.map.removeOverlay(vertexCoordinateOverlays[i]);
        }
        vertexCoordinateOverlays = [];

        /* 
        // Luego, crear nuevos overlays para los vértices finales
        const geometry = sketch.getGeometry();
        if (geometry instanceof Polygon) {
          const coordinates = geometry.getCoordinates()[0];

          for (let i = 0; i < coordinates.length - 1; i++) {
            const overlay = that.createVertexCoordinateTooltip(coordinates[i], that.map);
            if (overlay) overlay.set('type', 'area-coordinate');
          }
        }
        */

        measureTooltipElement.className = 'tooltip tooltip-static';
        measureTooltip.setOffset([0, -7]);

        // Hacer estáticos los tooltips de coordenadas
        vertexCoordinateOverlays.forEach(overlay => {
          const element = overlay.getElement();
          if (element) {
            element.className = 'tooltip tooltip-coordinate tooltip-static';
          }
        });

        sketch = null;
        measureTooltipElement = null;
        that.createMeasureTooltip();
        unByKey(listener);
      });
    },

    createHelpTooltip: function () {
      if (helpTooltipElement) {
        helpTooltipElement.parentNode.removeChild(helpTooltipElement);
      }
      helpTooltipElement = document.createElement('div');
      helpTooltipElement.className = 'tooltip hidden';
      helpTooltipArea = new Overlay({
        element: helpTooltipElement,
        offset: [15, 0],
        positioning: 'center-left'
      });
      helpTooltipArea.set('type', 'area');
      this.map.addOverlay(helpTooltipArea);
    },

    createMeasureTooltip: function () {
      console.log('create createMeasureTooltip');
      if (measureTooltipElement) {
        measureTooltipElement.parentNode.removeChild(measureTooltipElement);
      }
      measureTooltipElement = document.createElement('div');
      measureTooltipElement.className = 'tooltip tooltip-measure';
      measureTooltip = new Overlay({
        element: measureTooltipElement,
        offset: [0, -15],
        positioning: 'bottom-center'
      });
      measureTooltip.set('type', 'area');
      this.map.addOverlay(measureTooltip);
      tooltipOverlaysArea.push(measureTooltip);
    },

    addMeasureAreaInteraction: function () {
      this.injectCoordinateStyles();
      if (!isVectorArea) {
        this.map.addLayer(vectorArea);
        isVectorArea = true;
      }
      this.map.addEventListener('pointermove', pointerMoveArea);
      this.map.getViewport().addEventListener('mouseout', mouseOutArea);
      this.addAreaInteraction();

      //Mostrar overlays existentes
      this.map.getOverlays().forEach(overlay => {
        const type = overlay.get('type');
        if (type == 'area' || type == 'area-coordinate') {
          overlay.getElement().style.display = 'inherit';
        }
      });
    },

    removeMeasureAreaInteraction: function (deleteDrawing) {
      if (drawArea) {

        this.map.removeInteraction(drawArea);
        drawArea = null;

        this.map.removeEventListener('pointermove', pointerMoveArea, false);
        this.map.getViewport().removeEventListener('mouseout', mouseOutArea, false);
      }

      if (deleteDrawing) {
        isVectorArea = false;
        this.map.removeLayer(vectorArea);

        // Eliminar overlays de área
        for (let i = 0; i < tooltipOverlaysArea.length; i++) {
          this.map.removeOverlay(tooltipOverlaysArea[i]);
        }

        // Eliminar overlays de coordenadas de vértices
        // Eliminar overlays de coordenadas de vértices
        console.log('Limpiando', vertexCoordinateOverlays.length, 'tooltips de vértices');
        for (let i = 0; i < vertexCoordinateOverlays.length; i++) {
          this.map.removeOverlay(vertexCoordinateOverlays[i]);
        }

        // Force clean checks just in case arrays were desynced
        const overlays = this.map.getOverlays().getArray();
        const toRemove = [];
        overlays.forEach(overlay => {
          const type = overlay.get('type');
          if (type === 'area' || type === 'area-coordinate') {
            toRemove.push(overlay);
          }
        });
        toRemove.forEach(o => this.map.removeOverlay(o));

        //Vaciar tooltips
        tooltipOverlaysArea = [];
        vertexCoordinateOverlays = []; // Limpiar array de coordenadas

        //Vector nuevo
        sourceArea = new VectorSource();
        vectorArea = new VectorLayer({
          source: sourceArea,
          style: new Style({
            fill: new Fill({
              color: 'rgba(255, 255, 255, 0.2)'
            }),
            stroke: new Stroke({
              color: '#ffcc33',
              width: 2
            }),
            image: new CircleStyle({
              radius: 7,
              fill: new Fill({
                color: '#ffcc33'
              })
            })
          })
        });
      }
    },

    removeOnlyAreaInteraction: function () {
      this.map.removeInteraction(drawArea);
      drawArea = null;
      this.map.removeEventListener('pointermove', pointerMoveArea, false);
      this.map.getViewport().removeEventListener('mouseout', mouseOutArea, false);
    },

    cleanMeasureArea: function () {
      console.log('Limpiando medición de área y vértices');

      // 1. Buscar TODOS los overlays en el mapa que podrían ser de coordenadas
      const allOverlays = this.map.getOverlays().getArray();

      for (let i = allOverlays.length - 1; i >= 0; i--) {
        const overlay = allOverlays[i];
        const type = overlay.get('type');
        const element = overlay.getElement();

        if (
          type === 'area-coordinate' ||
          (element && element.className && element.className.includes('tooltip-coordinate')) ||
          (element && element.innerHTML &&
            (element.innerHTML.includes('Lat:') || element.innerHTML.includes('Lon:')))
        ) {
          console.log('Eliminando overlay:', type, element && element.innerHTML);
          this.map.removeOverlay(overlay);
        }
      }

      // 2. Limpiar también el array local
      vertexCoordinateOverlays = [];

      // 3. Proceder con la limpieza normal
      this.removeMeasureAreaInteraction(true);
      this.addMeasureAreaInteraction();
    },

    setMeasureAreaVisibility: function (isVisible) {
      if (isVisible) {
        this.map.addLayer(vectorArea);
        this.map.getOverlays().forEach(overlay => {
          const type = overlay.get('type');
          if (type == 'area' || type == 'area-coordinate') {
            overlay.getElement().style.display = 'inherit';
          }
        });
      } else {
        this.map.removeLayer(vectorArea);

        // Ocultar todos los overlays de área
        this.map.getOverlays().forEach(overlay => {
          const type = overlay.get('type');
          const element = overlay.getElement();

          if (type === 'area' || type === 'area-coordinate' ||
            (element && element.className && element.className.includes('tooltip-coordinate'))) {
            if (element) element.style.display = 'none';
          }
        });
      }
    },

    injectCoordinateStyles: function () {
      const styleId = 'measure-area-coordinate-styles';
      if (!document.getElementById(styleId)) {
        const styleElement = document.createElement('style');
        styleElement.id = styleId;
        styleElement.textContent = `
          .tooltip-coordinate {
            position: relative;
            background: rgba(0, 0, 0, 0.7);
            border-radius: 4px;
            color: white;
            padding: 4px 8px;
            opacity: 0.9;
            white-space: nowrap;
            font-size: 12px;
            pointer-events: none;
            z-index: 1000;
            max-width: 200px;
            text-align: center;
          }
          
          .tooltip-coordinate.tooltip-static {
            background-color: rgba(0, 0, 0, 0.7);
            color: white;
            border: 1px solid white;
          }
        `;
        document.head.appendChild(styleElement);
      }
    }
  }
};